export default "__VITE_ASSET__7ae39f3c__"